import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common";
import { PayableTab, ReceivableTab, ChallansTab, MonthlyTab } from "@/components/tds";

const TABS = [["payable", "Vendor TDS Payable"], ["receivable", "Party TDS Receivable"], ["monthly", "Monthly Liability Report"], ["challans", "Govt Deposits (Challans)"]];

export default function Tds() {
  const { role } = useAuth();
  const [tab, setTab] = useState("payable");
  return (
    <div className="space-y-5" data-testid="tds-page">
      <PageHeader title="TDS Management" subtitle="Vendor TDS payable, party TDS receivable aur sarkar ko jama TDS ka mahina-war hisaab" />
      <div className="flex flex-wrap gap-2" data-testid="tds-tabs">{TABS.map(([k, l]) => (
        <button key={k} type="button" data-testid={`tds-tab-${k}`} onClick={() => setTab(k)}
          className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${tab === k ? "bg-primary text-primary-foreground" : "bg-secondary hover:bg-accent"}`}>{l}</button>))}</div>
      {tab === "payable" && <PayableTab />}
      {tab === "receivable" && <ReceivableTab />}
      {tab === "monthly" && <MonthlyTab />}
      {tab === "challans" && <ChallansTab isAdmin={role === "admin"} />}
    </div>
  );
}
